/* @flow */
import Store from 'lib/Store';
import { ActionTypes as GroupActionTypes } from 'groups/constants/GroupConstants';
import MessageDeliverySummaries from 'collections/MessageDeliverySummaries';
import { PushEvents } from 'pusher/PusherConstants';

class DeliverySummaryStore extends Store {
  getInitialState() {
    return {
      loadedSummaries: {},
      summaries: new MessageDeliverySummaries(),
    };
  }

  isDeliverySummaryLoaded(messageId): boolean {
    return !!this.state.loadedSummaries[messageId];
  }

  getByMessageId(id) {
    return this.state.summaries.get(id);
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case GroupActionTypes.LOAD_DELIVERY_SUMMARY:
        this.state.loadedSummaries[action.messageId] = true;
        this.state.summaries.add(action.summary);
        this.emitChange();
        break;
      case PushEvents.CHANGESET_UPDATE_DELIVERY_UPDATES: {
        const messageUUIDS = action.changes.map(change => change.content.message_uuid);
        messageUUIDS.forEach(messageUUID => this.state.summaries.remove(messageUUID));
        break;
      }
      default:
        break;
    }
  }
}

export default new DeliverySummaryStore();



// WEBPACK FOOTER //
// ./src/stores/DeliverySummaryStore.js